package uz.ferro.erp.feature.order.ui

import mui.material.Card
import mui.system.sx
import react.FC
import react.Props
import uz.ferro.erp.Colors
import uz.ferro.erp.feature.order.model.Order
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.util.displayText
import uz.ferro.erp.util.formatDMYHm
import uz.ferro.erp.util.localized
import web.cssom.Cursor
import web.cssom.JustifyContent
import web.cssom.px
import kotlin.js.Date


external interface OrderListItemProps : Props {
    var order: Order
    var onItemClick: (Order) -> Unit
}

val OrderListItemView = FC<OrderListItemProps> { props ->
    val order = props.order
    Card {
        sx {
            padding = 12.px
            cursor = Cursor.pointer
        }

        onClick = {
            props.onItemClick(order)
        }

        VerticalLayout {
            space = 6.px

            HorizontalLayout {
                space = 12.px
                sx {
                    justifyContent = JustifyContent.spaceBetween
                }

                AppTextMedium {
                    text = "#${order.id}"
                }

                AppText {
                    text = Date(order.createdDate.orEmpty()).formatDMYHm()
                }
            }

            HorizontalLayout {
                space = 8.px
                AppText {
                    color = Colors.textSecondary
                    text = "Mahsulot"
                }

                AppText {
                    text = order.product?.title.localized()
                }
            }

            HorizontalLayout {
                space = 8.px
                AppText {
                    color = Colors.textSecondary
                    text = "Holati"
                }

                AppText {
                    text = order.status?.displayText()
                }
            }
        }
    }
}